var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdTheftInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm5.646 15.162C18.5 14.613 19 12.832 19 11V6.3l-7-3.11L5 6.3V11c0 1.838.493 3.617 1.347 5.167C8 14.937 10.744 14.5 12 14.5c1.255 0 3.993.436 5.646 1.662zm-1.12 1.655C15.62 17.101 13.553 16.5 12 16.5c-1.557 0-3.622.604-4.53 1.323 1.2 1.456 2.765 2.568 4.53 3.117 1.74-.53 3.28-1.62 4.47-3.04l.056-.083zM8.5 9.5C8.5 7.56 10.06 6 12 6s3.5 1.56 3.5 3.5S13.94 13 12 13s-3.5-1.56-3.5-3.5zm2 0c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S12.83 8 12 8s-1.5.67-1.5 1.5z",
    fill: "#424A56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdTheftInsurance);
export default __webpack_public_path__ + "static/media/id-theft-insurance.4bbcbc64fef6d713bd618f261d690024.svg";
export { ForwardRef as ReactComponent };